module.exports = __webpack_public_path__ + "img/6.ef59d423.png";